/* Boria kombin paketi: karışık ürün seçimi, seçimler seçili paketin içinde */
(() => {
  const shake = [{ transform: 'translateX(0)' }, { transform: 'translateX(-8px)' }, { transform: 'translateX(8px)' }, { transform: 'translateX(0)' }];
  const cache = {};
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const isColor = (n) => /renk|colou?r/i.test(n || '');

  function money(cents, fmt) {
    const cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (cur && window.Intl) {
      const v = (cents || 0) / 100;
      try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); } catch (e) {}
    }
    const n = (cents || 0) / 100;
    const f = (d, t, dec) => { const p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (d ? dec + p[1] : ''); };
    return (fmt || '{{amount}} TL').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: f(2, ',', '.'), amount_no_decimals: f(0, ',', '.'),
      amount_with_comma_separator: f(2, '.', ','), amount_no_decimals_with_comma_separator: f(0, '.', ','),
      amount_with_apostrophe_separator: f(2, "'", '.')
    }[k] || f(2, ',', '.')));
  }

  async function load(handle, self) {
    if (handle === self.handle) return self;
    if (cache[handle]) return cache[handle];
    const r = await fetch(`/products/${encodeURIComponent(handle)}.js`);
    const p = await r.json();
    cache[handle] = {
      handle, title: p.title,
      options: (p.options || []).map((o) => (typeof o === 'string' ? o : o.name)),
      variants: p.variants.map((v) => ({ id: v.id, options: v.options, available: v.available, price: v.price }))
    };
    return cache[handle];
  }

  async function addToCart(items, btn, msg, okText) {
    btn.disabled = true; msg.textContent = '';
    const cd = document.querySelector('cart-drawer');
    const holder = cd || document.querySelector('cart-notification');
    const sections = holder && holder.getSectionsToRender ? holder.getSectionsToRender().map((s) => s.id) : [];
    try {
      const res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: location.pathname })
      });
      const json = await res.json();
      if (json.status) throw new Error(json.description || json.message);
      if (holder && holder.renderContents) {
        const item = json.items ? json.items[0] : json;
        holder.renderContents(Object.assign({}, item, { sections: json.sections, id: item.id }));
        if (cd) cd.classList.remove('is-empty');
      } else location.href = (window.routes && window.routes.cart_url) || '/cart';
      msg.textContent = okText;
    } catch (e) { msg.textContent = e.message || 'Hata'; }
    btn.disabled = false;
  }

  function bundle(el) {
    const d = JSON.parse(el.querySelector('script[type="application/json"]').textContent);
    const self = d.self;
    const models = d.models || [];
    const btn = el.querySelector('[data-add]');
    const msg = el.querySelector('[data-msg]');
    const totalEl = el.querySelector('[data-total]');
    const grid = el.closest('.boria-buy__grid') || document;
    let q = +((el.querySelector('.boria-tier input:checked') || {}).value || 1);
    const pq = +(new URLSearchParams(location.search).get('paket') || 0);
    if (pq >= 1 && pq <= 3) { q = pq; const ri = el.querySelector(`.boria-tier input[value="${pq}"]`); if (ri) ri.checked = true; }
    let selfM = models.findIndex((m) => m.colors.some((c) => c.h === self.handle));
    if (selfM < 0) { models.unshift({ name: self.title.split(' – ')[0], price: (self.variants[0] || {}).price || 0, colors: [{ h: self.handle, n: '', img: '' }] }); selfM = 0; }
    const rows = [];

    const single = (p) => p.variants.length === 1 && /default/i.test(p.variants[0].options[0] || '');
    const prep = (p, r) => {
      if (!r.opts) { r.opts = p.options.map((n, k) => (r.keep && r.keep[k] && p.variants.some((v) => v.available && v.options[k] === r.keep[k]) ? r.keep[k] : null)); r.keep = null; }
      p.options.forEach((_, k) => { const vals = [...new Set(p.variants.map((v) => v.options[k]))]; if (vals.length === 1) r.opts[k] = vals[0]; });
    };
    const variantOf = (p, r) => single(p) ? (p.variants[0].available ? p.variants[0] : null) : p.variants.find((v) => v.available && v.options.every((o, k) => o === r.opts[k]));
    const ok = (p, r, k, val) => p.variants.some((v) => v.available && v.options[k] === val && v.options.every((o, j) => j === k || !r.opts[j] || o === r.opts[j]));
    const priceOf = (p, r) => { const v = variantOf(p, r) || p.variants.find((x) => x.available) || p.variants[0]; return v ? v.price : 0; };

    const paint = (name) => {
      const c = d.palette[name];
      if (!c) return;
      grid.querySelectorAll('.boria-jacket__base').forEach((x) => x.setAttribute('fill', c[0]));
      grid.querySelectorAll('.boria-jacket__pc').forEach((x) => x.setAttribute('flood-color', c[1]));
      grid.querySelectorAll('.boria-stage').forEach((s) => s._reveal && s._reveal.setColor(c[1]));
    };

    const colorHTML = (r, i) => {
      const m = models[r.m]; if (!m || m.colors.length < 2) return '';
      const cur = m.colors.find((c) => c.h === r.h) || m.colors[0];
      return `<div class="boria-opt"><span class="boria-opt__l">${d.t.color}: <b>${esc(cur.n)}</b></span><div class="boria-opt__v boria-opt__v--img">${m.colors.map((c) =>
        `<button type="button" class="boria-cthumb" data-i="${i}" data-h="${esc(c.h)}" aria-pressed="${c.h === r.h}" aria-label="${esc(c.n)}" title="${esc(c.n)}">${c.img ? `<img src="${c.img}" alt="" loading="lazy" width="44" height="55">` : `<span>${esc(c.n)}</span>`}</button>`).join('')}</div></div>`;
    };

    const optHTML = (p, r, i) => single(p) ? '' : p.options.map((name, k) => {
      const vals = [...new Set(p.variants.map((v) => v.options[k]))];
      if (vals.length < 2) return '';
      const col = isColor(name);
      return `<div class="boria-opt"><span class="boria-opt__l">${esc(name)}${r.opts[k] ? `: <b>${esc(r.opts[k])}</b>` : ''}</span><div class="boria-opt__v">${vals.map((val) => {
        const sw = col && d.palette[val];
        return `<button type="button" class="${sw ? 'boria-swatch boria-swatch--sm' : 'boria-size boria-size--sm'}" ${sw ? `style="--c:${sw[0]}"` : ''} data-i="${i}" data-k="${k}" data-v="${esc(val)}" aria-pressed="${r.opts[k] === val}" aria-label="${esc(val)}" ${ok(p, r, k, val) ? '' : 'disabled'}>${sw ? `<span>${esc(val)}</span>` : esc(val)}</button>`;
      }).join('')}</div></div>`;
    }).join('');

    const pickHTML = (r, i) => `<select class="boria-pick" data-pick="${i}" aria-label="${d.t.other}">
        ${models.map((m, mi) => `<option value="${mi}"${r.m === mi ? ' selected' : ''}>${esc(m.name)} · ${money(m.price, d.money)}${m.colors.length > 1 ? ` · ${m.colors.length} renk` : ''}</option>`).join('')}
      </select>`;

    async function render() {
      while (rows.length < q) rows.push({ m: selfM, h: self.handle, opts: null });
      const active = el.querySelector(`.boria-tier[data-q="${q}"]`);
      el.querySelectorAll('.boria-tier').forEach((t) => { t.classList.toggle('is-active', t === active); if (t !== active) t.querySelector('[data-items]').innerHTML = ''; });
      const body = active.querySelector('[data-items]');
      const prods = await Promise.all(rows.slice(0, q).map((r) => load(r.h, self).catch(() => null)));
      body.innerHTML = rows.slice(0, q).map((r, i) => {
        const p = prods[i]; if (!p) return '';
        prep(p, r);
        const inner = colorHTML(r, i) + optHTML(p, r, i);
        if (!inner && i === 0 && q === 1) return '';
        const nm = i === 0 && q > 1 ? `<span class="boria-item__name">${esc(p.title)}</span>` : '';
        return `<div class="boria-item" data-row="${i}">
          <div class="boria-item__top"><span class="boria-item__n">${q > 1 ? `${i + 1}. ${d.t.item}` : ''}</span>${i > 0 ? pickHTML(r, i) : nm}</div>
          ${inner}
        </div>`;
      }).join('');
      const prices = rows.slice(0, q).map((r, i) => (prods[i] ? priceOf(prods[i], r) : 0));
      const full = prices.reduce((a, b) => a + b, 0);
      const pct = d.pct[q] || 0;
      const total = full - Math.round(Math.min(...prices) * pct / 100);
      const tp = active.querySelector('[data-tp]'), tf = active.querySelector('[data-tf]');
      if (tp) tp.textContent = money(total, d.money);
      if (tf) tf.textContent = money(full, d.money);
      totalEl.textContent = money(total, d.money);
      el._prods = prods;
    }

    el.addEventListener('change', (e) => {
      if (e.target.name && /-tier$/.test(e.target.name)) { q = +e.target.value; msg.textContent = ''; render(); }
      const pi = e.target.dataset && e.target.dataset.pick;
      if (pi !== undefined) { const m = models[+e.target.value]; rows[+pi] = { m: +e.target.value, h: m.colors[0].h, opts: null }; msg.textContent = ''; render(); }
    });
    el.addEventListener('click', (e) => {
      const c = e.target.closest('[data-h]');
      if (c && q === 1 && +c.dataset.i === 0 && c.dataset.h !== self.handle) { location.href = '/products/' + c.dataset.h + '?paket=' + q; return; }
      if (c) { const r = rows[+c.dataset.i]; if (r.h !== c.dataset.h) { r.h = c.dataset.h; const keep = r.opts; r.opts = null; r.keep = keep; } msg.textContent = ''; render().then(() => {}); return; }
      const b = e.target.closest('[data-k]'); if (!b || b.disabled) return;
      const i = +b.dataset.i, k = +b.dataset.k, r = rows[i], p = el._prods && el._prods[i];
      r.opts[k] = b.dataset.v;
      if (p) p.options.forEach((_, j) => { if (j !== k && r.opts[j] && !ok(p, r, j, r.opts[j])) r.opts[j] = null; });
      if (i === 0 && p && isColor(p.options[k])) paint(b.dataset.v);
      msg.textContent = ''; render();
    });
    btn.addEventListener('click', () => {
      const prods = el._prods || [];
      const sel = rows.slice(0, q);
      const bad = sel.findIndex((r, i) => !prods[i] || !variantOf(prods[i], r));
      if (bad > -1) { msg.textContent = d.t.pick; const n = el.querySelector(`.boria-tier.is-active [data-row="${bad}"]`); if (n) n.animate(shake, { duration: 350 }); return; }
      const map = {};
      sel.forEach((r, i) => { const v = variantOf(prods[i], r); map[v.id] = (map[v.id] || 0) + 1; });
      addToCart(Object.keys(map).map((id) => ({ id: +id, quantity: map[id] })), btn, msg, d.t.added);
    });
    render().then(() => {
      const ci = self.options.findIndex(isColor);
      if (ci > -1 && rows[0].opts && rows[0].opts[ci]) paint(rows[0].opts[ci]);
    });
  }

  const init = (scope = document) => scope.querySelectorAll('[data-boria-bundle]:not([data-ready])').forEach((el) => { el.dataset.ready = 1; bundle(el); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
